import { Component, input, output } from '@angular/core';
import { CommentListComponent } from '../comment-list/comment-list.component';
import { CommentFormComponent } from '../../molecules/comment-form/comment-form.component';
import type { CommentItem } from '../comment-list/comment-list.interfaces';

@Component({
  selector: 'ocp-comment-section',
  templateUrl: './comment-section.component.html',
  styleUrl: './comment-section.component.scss',
  imports: [CommentListComponent, CommentFormComponent],
})
export class CommentSectionComponent {
  readonly comments = input.required<CommentItem[]>();
  readonly userInitials = input('');
  readonly userColorSeed = input<string | undefined>(undefined);

  readonly addComment = output<string>();
  readonly commentClose = output<CommentItem>();
}
